export const PAPERSHELF_CATEGORIES = [
  'Cloud Security',
  'DevOps',
  'Architecture',
  'Performance',
  'Data Privacy & Security'
];

export const ARCHIVE_CATEGORIES = [
  'All Archived',
  'Classic Papers',
  'Completed Research',
  'Legacy Systems'
];

export const papers = [
  {
    id: 'yandex-secret-detection',
    title: "Secret Ingredients for Secure Development: Achieving Fast and Accurate Secret Detection",
    authors: "Yandex Research Team",
    startedAt: "October 2025",
    category: "Data Privacy & Security",
    link: "https://medium.com/yandex/secret-ingredients-for-secure-development-achieving-fast-and-accurate-secret-detection-0cf351e74250",
    status: "Currently Reading",
    excerpt: "Fine-tuned small language models for secrets detection achieving 86% precision and 82% recall. Focus on API keys, passwords, and tokens in code.",
    tags: ["Machine Learning", "Security", "Code Analysis"],
    readingTime: "8 min read"
  },
  {
    id: 'palo-alto-slms-cybersecurity',
    title: "Small Language Models in Cybersecurity: Revolutionizing Data Loss Prevention",
    authors: "Palo Alto Networks",
    startedAt: "October 2025",
    category: "Data Privacy & Security",
    link: "https://live.paloaltonetworks.com/t5/community-blogs/how-small-language-models-are-quietly-revolutionizing/ba-p/1233840",
    status: "Currently Reading",
    excerpt: "Encoder-only SLMs with context-aware pattern detection for PII detection including SSNs and credit cards in enterprise data streams.",
    tags: ["Cybersecurity", "PII Detection", "Data Loss Prevention"],
    readingTime: "6 min read"
  },
  {
    id: 'piivot-nlp-anonymization',
    title: "PIIvot: A Lightweight NLP Anonymization Framework for Question-Anchored Tutoring Dialogues",
    authors: "Matthew Zent, Digory Smith, Simon Woodhead",
    startedAt: "August 2025",
    category: "Data Privacy & Security",
    link: "https://arxiv.org/abs/2505.16931",
    status: "Completed",
    excerpt: "A framework designed for anonymizing PII in educational dialogues, highlighting the importance of context-aware data classification in sensitive environments.",
    tags: ["NLP", "Privacy", "Anonymization", "Education"],
    readingTime: "12 min read"
  },
  {
    id: 'dynamodb-streams-architecture',
    title: "DynamoDB Streams: Building Real-time Applications with Change Data Capture",
    authors: "Amazon Web Services",
    startedAt: "January 2025",
    category: "Data Streaming",
    link: "https://docs.aws.amazon.com/amazondynamodb/latest/developerguide/Streams.html",
    status: "Completed",
    excerpt: "Comprehensive guide to building real-time applications using DynamoDB Streams for change data capture and event-driven architectures.",
    tags: ["AWS", "Real-time", "Event Streaming", "Database"],
    readingTime: "15 min read"
  },
  {
    id: 'mapreduce-simplified-data-processing',
    title: "MapReduce: Simplified Data Processing on Large Clusters",
    authors: "Google Research",
    startedAt: "July 2025",
    category: "Distributed Systems",
    link: "https://research.google/pubs/pub62/",
    status: "Completed",
    excerpt: "The foundational paper introducing MapReduce programming model for processing and generating large data sets on distributed systems.",
    tags: ["Distributed Systems", "Big Data", "Google", "Classic"],
    readingTime: "20 min read",
    archived: true,
    archiveCategory: "Classic Papers"
  },
  {
    id: 'cache-efficient-topk-aggregation',
    title: "Cache-Efficient Top-k Aggregation over High Cardinality Large Datasets",
    authors: "Bing Research (Microsoft)",
    startedAt: "June 2025",
    category: "Caching",
    link: "https://www.microsoft.com/en-us/research/publication/cache-efficient-top-k-aggregation-over-high-cardinality-large-datasets/",
    status: "Completed",
    excerpt: "Research on optimizing top-k aggregation queries over large datasets with high cardinality using cache-efficient algorithms.",
    tags: ["Caching", "Performance", "Microsoft", "Algorithms"],
    readingTime: "18 min read",
    archived: true,
    archiveCategory: "Completed Research"
  },
  {
    id: 'monitoring-distributed-systems',
    title: "Monitoring Distributed Systems",
    authors: "Google SRE Team",
    startedAt: "May 2025",
    category: "Observability",
    link: "https://sre.google/sre-book/monitoring-distributed-systems/",
    status: "Completed",
    excerpt: "Essential guide to monitoring distributed systems from Google's SRE team, covering metrics, alerting, and observability best practices.",
    tags: ["SRE", "Monitoring", "Google", "Observability"],
    readingTime: "25 min read",
    archived: true,
    archiveCategory: "Completed Research"
  },
  {
    id: 'aws-well-architected-framework',
    title: "AWS Well-Architected Framework",
    authors: "Amazon Web Services",
    startedAt: "April 2025",
    category: "Cloud Architecture",
    link: "https://docs.aws.amazon.com/wellarchitected/latest/framework/welcome.html",
    status: "Completed",
    excerpt: "Comprehensive framework for building secure, high-performing, resilient, and efficient cloud infrastructure on AWS.",
    tags: ["AWS", "Architecture", "Best Practices", "Cloud"],
    readingTime: "30 min read",
    archived: true,
    archiveCategory: "Completed Research"
  },
  {
    id: 'dynamodb-nosql-database-service',
    title: "DynamoDB: A NoSQL Database Service for All Scale Applications",
    authors: "Amazon Web Services",
    startedAt: "March 2025",
    category: "Database",
    link: "https://www.usenix.org/system/files/atc22-elhemali.pdf",
    status: "Completed",
    excerpt: "Technical deep dive into DynamoDB's architecture, design principles, and how it scales to handle massive workloads.",
    tags: ["DynamoDB", "NoSQL", "AWS", "Database"],
    readingTime: "22 min read",
    archived: true,
    archiveCategory: "Legacy Systems"
  },
  {
    id: 'amazon-s3-best-practices',
    title: "Amazon S3 Best Practices",
    authors: "Amazon Web Services",
    startedAt: "March 2025",
    category: "Storage",
    link: "https://d1.awsstatic.com/whitepapers/AmazonS3BestPractices.pdf",
    status: "Completed",
    excerpt: "Comprehensive guide to Amazon S3 best practices for security, performance, cost optimization, and operational excellence.",
    tags: ["S3", "Storage", "AWS", "Best Practices"],
    readingTime: "16 min read",
    archived: true,
    archiveCategory: "Legacy Systems"
  }
];
